import {
  saveSetupData as sharedSaveSetupData,
  getSetupData as sharedGetSetupData,
  clearSetupData as sharedClearSetupData,
  hasSetupData as sharedHasSetupData,
} from '@gastrosoft/shared/utils';

const STEP_KEYS = ['organization', 'organizationAddress', 'customerContact'] as const;

export interface SetupData {
  organization?: unknown;
  organizationAddress?: unknown;
  customerContact?: unknown;
}

export const saveSetupData = sharedSaveSetupData;
export const getSetupData = sharedGetSetupData;

export const clearSetupData = (): void => sharedClearSetupData([...STEP_KEYS]);

export const hasSetupData = (): boolean => sharedHasSetupData([...STEP_KEYS]);

export const getAllSetupData = (): SetupData => ({
  organization: sharedGetSetupData('organization'),
  organizationAddress: sharedGetSetupData('organizationAddress'),
  customerContact: sharedGetSetupData('customerContact'),
});
